import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';

export default class ContactSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'ContactSearchParams';

  initialize() {
    this.ContactId = '';
    this.IsActive = 'true';
    this.OfficeId = OfficeHelper.GetDefaultOfficeIds(2);
    this.Name = '';
    this.Email = '';
    this.BillToClientName = '';
    this.Phone = '';
    this.Client = '';
    this.AllowBulkEmail = '';
    this.AllowEmail = '';
    this.AllowFax = '';
    this.AllowPhone = '';
    this.AllowPostalMail = '';
    this.AllowSocialMedia = '';
    this.ClientId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ContactId', label: 'Contact Id', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'IsActive', label: 'Is Active', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'OfficeId', label: 'Office', className: 'col-3', type: InputTypesEnum.OfficeOrGroupMultiSelect },
    { fieldName: 'Name', label: 'Name', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'Email', label: 'Email', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'BillToClientName', label: 'Bill To Client Name', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'Phone', label: 'Phone', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'Client', label: 'Client', className: 'col-3', type: InputTypesEnum.ClientSelect },
    {
      fieldName: 'AllowBulkEmail',
      label: 'Allow Bulk Email',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    { fieldName: 'AllowEmail', label: 'Allow Email', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'AllowFax', label: 'Allow Fax', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'AllowPhone', label: 'Allow Phone', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'AllowPostalMail',
      label: 'Allow Postal Mail',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'AllowSocialMedia',
      label: 'Allow Social Media',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];
}
